import { SVGPureIcon } from "@/ui"

const ErrorMask = ({ imageResult }) => {
  return (
    <div className='absolute inset-0 flex flex-col leading-[18px] items-center justify-center overflow-hidden text-12px text-[rgba(255,255,255,0.60)] backdrop-filter backdrop-blur-10px bg-[rgba(0,0,0,.3)]'>
      <img className="w-80px h-80px" src="https://p5.ssl.qhimg.com/t110b9a9301f0792b96f4dcd5ab.png" alt="" />
      <div>生成失败</div>
    </div>
  )
}

export default ErrorMask;